// Ordered list of [path, module] used to resolve a user's landing page based on permissions.
export const ROUTE_MODULES = [
  ["/", "dashboard"],
  ["/dpr", "dpr"],
  ["/stock", "stock"],
  ["/scrap", "scrap"],
  ["/power", "power"],
  ["/inward-outward", "gatepass"],
  ["/electrolysis", "electrolysis"],
  ["/buffing", "buffing"],
  ["/approvals", "approvals"],
  ["/audit", "audit"],
  ["/processes", "processes"],
  ["/inventory", "inventory"],
  ["/bom", "bom"],
  ["/cost-sheet", "cost-sheet"],
];

// Returns the first route the user can read, or null if they have no accessible module.
export function firstAllowedPath(canRead, isSuper) {
  if (isSuper) return "/";
  const found = ROUTE_MODULES.find(([, m]) => canRead(m));
  return found ? found[0] : null;
}
